import { styled } from '@mui/material';
import Link from '@mui/material/Link';

import { COLORS } from '~/styles/colors';
import { mainPreviewContainerStyles } from '~/styles/common';

export const StyledContainer = styled('div')({
  ...mainPreviewContainerStyles,
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flexDirection: 'column',
});

export const StyledUserNameContainer = styled('div')({
  padding: 16,
  paddingBottom: 28,
  paddingTop: 38,
  textAlign: 'center',
  backgroundColor: COLORS.blue,
  width: 'calc(100% - 4px)',
  fontSize: 18,
  minHeight: 80,
  boxSizing: 'border-box',
  wordBreak: 'break-word',
  color: COLORS.white,
  margin: '0 auto',
  borderRadius: '32px 32px 0 0',
});

export const StyledContentContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  color: COLORS.black08,
  borderBottom: `1px solid ${COLORS.grey200}`,
  width: 'calc(100% - 4px)',
  margin: '0 auto',
});

export const StyledListItem = styled('div')({
  display: 'flex',
  gap: 16,
  padding: 8,
  alignItems: 'center',
});

export const StyledListItemText = styled(Link)({
  wordBreak: 'break-word',
  fontSize: 16,
  color: COLORS.black08,
  textDecoration: 'none',
});
